var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChessRook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 32H312C303.125 32 296 39.125 296 48V96H248V48C248 39.125 240.875 32 232 32H152C143.125 32 136 39.125 136 48V96H88.125V48C88.125 39.125 80.875 32 72.125 32H16C7.125 32 0 39.125 0 48V224L64 256C64 304.375 62.5 351 50.75 416H333.25C321.5 351 320 303.75 320 256L384 224V48C384 39.125 376.875 32 368 32ZM224 320H160V256C160 238.375 174.375 224 192 224S224 238.375 224 256V320ZM336 448H48C21.49 448 0 469.49 0 496V496C0 504.837 7.163 512 16 512H368C376.837 512 384 504.837 384 496V496C384 469.49 362.51 448 336 448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessRook);
export default __webpack_public_path__ + "static/media/chess-rook.060463f184179fd43430217099f0993f.svg";
export { ForwardRef as ReactComponent };